import { Controller } from "@hotwired/stimulus"

const DIALOG_IDENTIFIER = "poetry--core--dialog"

export default class extends Controller {
  static targets = ["note"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    if (!this.openValue) this.syncNote()
  }

  // Fires on connect and when a 422 morph flips the value from false to true
  // without reconnecting this controller.
  openValueChanged(value) {
    if (!value) return
    this.openTries = 0
    this.openDialog()
  }

  reasonChanged(event) {
    this.syncNote(event.detail?.value)
  }

  syncNote(value = this.currentReason()) {
    if (!this.hasNoteTarget) return
    const show = value === "other" || Boolean(this.noteTarget.querySelector("[data-slot='field-error']"))
    this.noteTarget.toggleAttribute("hidden", !show)
  }

  currentReason() {
    return this.element.querySelector("[data-slot='select-native']")?.value || ""
  }

  openDialog() {
    const panel = this.element.querySelector("[data-slot='dialog-content']")
    if (panel?.open) return

    const root = this.element.querySelector(`[data-controller~="${DIALOG_IDENTIFIER}"]`)
    const dialog = root && this.application.getControllerForElementAndIdentifier(root, DIALOG_IDENTIFIER)
    if (dialog) {
      dialog.open()
      if (panel?.open) return
    } else {
      this.element.querySelector("[data-action*='poetry--core--dialog#open']")?.click()
    }

    this.openTries += 1
    if (this.openTries < 12) requestAnimationFrame(() => this.openDialog())
  }
}
